module.exports = __webpack_public_path__ + "img/626.Plates.cad105b9.svg";